import { Injectable } from '@angular/core';
import { Customer, CustomerService } from 'spotlight-ui/app/core/customer.service';
import { UserService } from 'spotlight-ui/app/core/user';
import { Observable, ReplaySubject } from 'rxjs';
import { UserLocation } from 'spotlight-ui/app/models/user/location.model';

export interface CustomerDisplay {
  firstName: string;
  lastName: string;
  id: string;
  fullName: string;
}
@Injectable()
export class CustomersNameService {
  constructor(
        private readonly customerService: CustomerService,
        private readonly userService: UserService,
  ) {}

  public populateCustomerNames(ids: string[]): Observable<CustomerDisplay[]> {
    const customers: ReplaySubject<CustomerDisplay[]> = new ReplaySubject<CustomerDisplay[]>();
    ids = ids ?? [];
    this.userService.getSelectedLocation().subscribe({
      next: (location: UserLocation) => {
        this.customerService.getCustomerProfiles(location.locationNumber, ids).subscribe({
          next: (profiles: Customer[]) => {
            const profilesMap = new Map(profiles.map(profile => [profile.cfaID, profile]));
            const displayProfiles = ids.map(value => {
              const profile = profilesMap.get(value);
              return {
                id: value,
                firstName: profile?.firstName || '',
                lastName: profile?.lastName || '',
                fullName: profile?.firstName + ' ' + profile?.lastName || ''
              };
            });
            customers.next(displayProfiles);
            customers.complete();
          },
          error: error => customers.error(error)
        });
      },
      error: error => customers.error(error)
    });
    return customers.asObservable();
  }

}
